<template>
  <div class="grid grid-cols-1 gap-2 sm:grid-cols-2">
    <template v-for="button in buttons">
     <home-button v-bind:key="button.title" :title="button.title" :blueprintid="button.blueprintid" :validate="button.validate"/>
    </template>
  </div>
</template>
<script>

import HomeButton from '@/components/HomeButton'
export default {
  name: 'home-button-field',
  components: {
    HomeButton
  },
  data() {
    return {
      buttons: []
    }
  },
  props: {
    field: {
      type: Object,
      required: true
    },
  },

  created() {
    this.getButtons();
  },
  methods: {
    async getButtons() {
      let config = {
        params: {
          ...this.$store.state.data
        }
      }
      const response = await this.$http.get(this.field.uri, config)
      console.log(response.data)
      this.buttons = response.data
    }
  }
}
</script>
